import { useState, forwardRef } from "react";
import Modal, { CommonModalProps } from "..";
import { Autocomplete, Button, InputLabel, OutlinedInput, Stack } from "@mui/material";
import { userService } from "../../../Core/Api/services";
import moment from "moment";
import { DbSearchAdvancedQueryInfos } from "../../../Core/Api/Types/db-search-advanced-query-infos";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useTranslation } from "react-i18next";

export type ModalAdvancedQueryElementProps = {
  query: string;
  queries: DbSearchAdvancedQueryInfos[];
  layer: ObjectLayer;
  textSearch: string;
  addQuery: React.Dispatch<React.SetStateAction<DbSearchAdvancedQueryInfos[]>>;
};

export type ModalAdvancedQueryProps = CommonModalProps<ModalAdvancedQueryElementProps>;

const ModalSCreateAdvancedQuery = forwardRef<any, ModalAdvancedQueryProps>((props, ref) => {
  const { closeModal, query, queries, addQuery, layer, textSearch } = props;
  const { t } = useTranslation();
  const [pattern, setPattern] = useState(textSearch);
  const [title, setTitle] = useState("");
  const [advancedQuery, setAdvancedQuery] = useState(query || "");
  const [queryLayer, setLayer] = useState<ObjectLayer | null>(layer);

  const handleCancelClick = () => {
    closeModal();
  };

  const handleCreateClick = () => {
    let newQuery: DbSearchAdvancedQueryInfos = {
      name: title,
      query: advancedQuery,
      userId: 2,
      platformId: 1,
      date: moment().toDate(),
      id: -500,
      isNew: true,
      layer: queryLayer,
      sharedWithUserIds: null,
      pattern: pattern,
    };
    userService.PutSearchQueries(newQuery).then(function (response) {
      if (response.success) addQuery([...queries, newQuery]);
      closeModal();
    });
  };

  return (
    <Modal title={t("modal:title.createAdvancedQuery")} reference={ref} closeModal={handleCancelClick} width={750}>
      <InputLabel sx={{ mb: "6px" }} htmlFor={"title"}>
        {t("common:title")}
      </InputLabel>
      <OutlinedInput onChange={(e) => setTitle(e.target.value)} value={title} sx={{ mb: 2 }} />
      <InputLabel sx={{ mb: "6px" }} htmlFor={"textSearch"}>
        {t("common:pattern")}
      </InputLabel>
      <OutlinedInput
        onChange={(e) => {
          setPattern(e.target.value);
        }}
        value={pattern}
        sx={{ mb: 2 }}
      />
      <InputLabel sx={{ mb: "6px" }} htmlFor={"type"}>
        {t("common:type")}
      </InputLabel>
      <Autocomplete
        id={"type"}
        options={[ObjectLayer.Asset, ObjectLayer.Content, ObjectLayer.Title]}
        onChange={(e, value) => setLayer(value)}
        value={queryLayer}
        popupIcon={<ExpandMoreRoundedIcon />}
        isOptionEqualToValue={(option, _value) => option === _value}
        renderInput={(params) => (
          <OutlinedInput {...params.InputProps} inputProps={params.inputProps} required sx={{ width: "100%" }} />
        )}
        sx={{ mb: 2 }}
      />
      <InputLabel sx={{ mb: "6px" }} htmlFor={"query"}>
        {t("common:query")}
      </InputLabel>
      <OutlinedInput onChange={(e) => setAdvancedQuery(e.target.value)} value={advancedQuery} sx={{ mb: 2 }} />
      <Stack direction="row" justifyContent="flex-end" mt={2} spacing={1}>
        <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateClick}
          disabled={title === "" || advancedQuery === "" || queryLayer === null || pattern === ""}
        >
          {t("common:create")}
        </Button>
      </Stack>
    </Modal>
  );
});

export default ModalSCreateAdvancedQuery;
